<template>
    <section class="forgot-password-popup global-popup">
        <div class="container">
            <div class="column-wrapper">
                <div class="column form">
                    <div class="title-wrapper">
                        <h2 class="column-title">Wachtwoord vergeten?</h2>
                        <p class="subtitle">Vul je gegevens in voor een reset link</p>
                    </div>

                    <ForgotPasswordForm />
                    <button class="back-to-login" @click="hidePopups">
                        Terug naar log in
                    </button>
                    <button class="close-btn" @click="hidePopups"></button>
                </div>
            </div>
        </div>

        <div class="background-el" @click="hidePopups"></div>
    </section>
</template>

<script>
import { defineComponent } from 'vue';

import ForgotPasswordForm from '@/components/Forms/ForgotPasswordForm.vue';

import { useGlobalStore } from '@/stores/global';

export default defineComponent({
    name: 'ForgotPasswordFormPopup',
    components: {
        ForgotPasswordForm
    },
    setup(props, { emit }) {
        const globalStore = useGlobalStore();

        function showLoginPopup() {

            //globalStore.showLoginPopup();
            globalStore.hidePasswordPopup();
        };
        function hidePopups() {
            globalStore.hideLoginPopup();
            globalStore.hidePasswordPopup();
        };

        return {
            showLoginPopup,
            hidePopups
        }
    }
});
</script>

<style lang="scss" scoped>
// @import styles
@import './index.scss';
</style>
